import { render } from "./ChangeLogEntry.vue?vue&type=template&id=b8db6b24&scoped=true&ts=true"
import script from "./ChangeLogEntry.vue?vue&type=script&lang=ts"
export * from "./ChangeLogEntry.vue?vue&type=script&lang=ts"

import "./ChangeLogEntry.vue?vue&type=style&index=0&id=b8db6b24&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8db6b24"]])

export default __exports__